import React from "react";

import { env } from "~/env";
import { ROUTES } from "~/router";
import BackButton from "~/screens/Auth/components/BackButton";
import { Title, usePageTitle } from "~/shared";

export const MoreInformation = () => {
  usePageTitle("More Information");

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-10 md:flex-col md:items-start md:gap-0">
        <BackButton variant="violet" to={ROUTES.hubBookVisit} />

        <Title className="text-xl">Visits at Elektra</Title>
      </div>

      <div className="max-w-5xl space-y-6">
        <section>
          <h2 className="text-indigo-charcoal mb-3 text-base font-semibold">
            Clinician vs. Coach
          </h2>
          <div className="space-y-4 text-base text-gray-600">
            <div>
              <p>
                Elektra's board-certified clinicians specialize in menopause and
                midlife women's health. They provide telemedicine care in select
                states and can order labs and prescribe as needed.
              </p>
            </div>
            <div>
              <p>
                Elektra coaches provide symptom-specific lifestyle
                recommendations (nutrition, exercise, etc), as well as education
                and emotional support. Coaches can see members in all states for
                non-clinical support.
              </p>
            </div>
          </div>
        </section>

        <section>
          <h2 className="text-indigo-charcoal mb-3 text-base font-semibold">
            States
          </h2>
          <div className="space-y-2 text-base text-gray-600">
            <p>
              <span>Clinical care:</span> AZ, CT, FL, GA, IL, IA, MA, MO, NE,
              NJ, NY, OH, OK, PA, TN, TX
            </p>
            <p>
              <span>Coaching:</span> All states
            </p>
          </div>
        </section>

        <section>
          <h2 className="text-indigo-charcoal mb-3 text-base font-semibold">
            Insurance coverage
          </h2>
          <div className="space-y-2 text-base text-gray-600">
            <p>
              Clinical care is covered by select insurance plans, and Elektra is
              actively working to expand coverage with others. We also accept
              out-of-pocket patients and can provide a superbill you can submit
              to your insurance carrier for out-of-network reimbursement.
            </p>
            <p>
              Visits with a coach are $0 if your plan covers coaching, or
              $99/session otherwise.
            </p>
          </div>
        </section>

        <section>
          <h2 className="text-indigo-charcoal mb-3 text-base font-semibold">
            Cancellations
          </h2>
          <div className="space-y-2 text-base text-gray-600">
            <p>
              Need to cancel or reschedule? Email{" "}
              <a
                href="mailto:care@elektrahealth.com"
                className="text-violet hover:underline"
              >
                care@elektrahealth.com
              </a>{" "}
              or text{" "}
              <a
                href="tel:+16467606669"
                className="text-violet hover:underline"
              >
                (646) 760-6669
              </a>
              . Please be sure to cancel at least 24 hours in advance to avoid
              incurring a ${env.VITE_LATE_CANCELLATION_FEE} charge.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};
